
import RoleTable from 'components/Settings/Role';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const Roles = () => {
	const selectedCompanyPermission = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);
		const isRolePermission = checkPermission(selectedCompanyPermission, {
			permissionName: 'Roles',
			permission: ['view'],
		});

	return <div>{isRolePermission  && <RoleTable />}</div>;
};
